(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["theme-cart-drawer"]) return;
  try {
    

  // Single close routine so the accessible-dialog helper (focus return,
  // aria-hidden cleanup) always runs alongside the visual hide.
  window.closeCartDrawer = function () {
    $('.cart_drawer_overlay').removeClass('active');
    if (window.a11yDialog) {
      window.a11yDialog.close(document.querySelector('.cart_drawer'));
    }
  };

  $('.cart_drawer button.close').click(function() {
    window.closeCartDrawer();
  });

  $('.cart_drawer_overlay').click(function(e) {
    if (e.target === this) {
      window.closeCartDrawer();
    }
  });


  } catch(e) { console.error(e); }
})();
})();
